<template lang="pug">
    BSidebar#the-companion-nav(
      :fullheight="false"
      :open.sync="open"
      :reduce="true"
      :overlay="isInsideIframe ? false : isMobile"
      :can-cancel="isInsideIframe ? false : isMobile"
      @close="isMobile ? '' : ''"
    )
      BMenu
        BMenuList
          BMenuItem.icon-item.mt-2(tag="router-link" :to="{ name: 'Companion'}")
            template(slot="label")
                WtSvgIcon(
                  icon="companion/all" 
                  width="20px" 
                  height="20px"
                )
  
          BMenuItem.icon-item(tag="router-link" :to="{ name: 'Companion'}")
            template(slot="label")
                WtSvgIcon(
                    icon="companion/headphone" 
                    width="20px" 
                  height="20px"
                    )
          BMenuItem.icon-item(tag="router-link" :to="{ name: 'Companion'}")
            template(slot="label")
                WtSvgIcon(
                    icon="companion/breath" 
                    width="20px" 
                  height="20px"
                    )
          BMenuItem.icon-item(tag="router-link" :to="{ name: 'Companion'}")
            template(slot="label")
                WtSvgIcon(
                    icon="companion/workshop" 
                    width="20px" 
                  height="20px"
                    )
          BMenuItem.icon-item(tag="router-link" :to="{ name: 'CompanionArticle' , params:{ articleId:'0b47ab52-e49b-4689-ac16-e484e737e126' }}")
            template(slot="label")
                WtSvgIcon(
                    icon="companion/article" 
                    width="20px" 
                  height="20px"
                    )
          BMenuItem.icon-item.mb-2(tag="router-link" to="#")
            template(slot="label")
                WtSvgIcon(
                    icon="companion/journal" 
                    width="20px" 
                  height="20px"
                    )
  
  </template>

<script>
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";

export default {
  name: "CompanionNavBar",
  components: {
    WtSvgIcon
  },
  data() {
    return {
      open: true,
      reduce: false,
      isInsideIframe: true,
      sidebarReduced: true,
      isMobile: false
    };
  }
};
</script>

<style lang="sass">
#the-companion-nav
    background-color: $white;
    position: fixed;
    top: 25%;
    transform: translateY(-30%);
    width: 100px
    .sidebar-content
        border-top-right-radius: 25px
        border-bottom-right-radius: 25px
        outline: 1px solid $grey-light
        max-width: 64px

    .icon-item
        padding: 5px;
        padding-left: 8px;
</style>
